import axios from "axios";
import { ApiKey, liveURL } from "../../const/constants";

const MAIN_URL_DIARY = `${liveURL}/websiteDiary`;
const GET_DIARIES = `${MAIN_URL_DIARY}/getNoorDiaries`;
const GET_DIARY_BY_ID = `${MAIN_URL_DIARY}/getNoorDiaryById`;
const MAIN_URL_MUJALLAH = `${liveURL}/websiteMujjalah`;
const GET_MUJALLAHS = `${MAIN_URL_MUJALLAH}/getMujallahs`;
const GET_MUJALLAH_BY_ID = `${MAIN_URL_MUJALLAH}/getMujjalahById`;
const GET_OUR_BOOKS = `${liveURL}/websitematbuaat/getBooks`;
const GET_BOOK_BY_ID = `${liveURL}/websitematbuaat/getBook`;

const handleError = (error, endpoint) => {
  console.error(`Error at ${endpoint}:`, {
    message: error.message,
    status: error.response?.status,
    data: error.response?.data,
  });
  return { Result: false, error: error.message };
};
export async function getOurBooks() {
  try {
    const response = await axios.get(GET_OUR_BOOKS, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return handleError(error, GET_MUJALLAHS);
  }
}
export async function getBookById(id) {
  if (!id) {
    console.error(" No ID provided");
    return { Result: false, error: "No ID provided" };
  }

  try {
    const response = await axios.get(`${GET_BOOK_BY_ID}/${id}`, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return handleError(error, `${GET_DIARY_BY_ID}/${id}`);
  }
}
export async function getMujallah() {
  try {
    const response = await axios.get(GET_MUJALLAHS, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return handleError(error, GET_MUJALLAHS);
  }
}

export async function getMujallahById(id) {
  if (!id) {
    console.error("getMujallahById: No ID provided");
    return { Result: false, error: "No ID provided" };
  }

  try {
    const response = await axios.get(`${GET_MUJALLAH_BY_ID}/${id}`, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return handleError(error, `${GET_MUJALLAH_BY_ID}/${id}`);
  }
}

export async function getNoorDiary() {
  try {
    const response = await axios.get(GET_DIARIES, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return handleError(error, GET_DIARIES);
  }
}

export async function getDiaryById(id) {
  if (!id) {
    console.error("getDiaryById: No ID provided");
    return { Result: false, error: "No ID provided" };
  }

  try {
    const response = await axios.get(`${GET_DIARY_BY_ID}/${id}`, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    return handleError(error, `${GET_DIARY_BY_ID}/${id}`);
  }
}
